import CircularProgress from "@material-ui/core/CircularProgress"

export function Loading(): JSX.Element {
    return (
        <div className="flex h-full w-full">
            <CircularProgress className="m-auto" />
        </div>
    )
}
